var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAssets(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "status-up"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M6.87988 18.9001C6.46988 18.9001 6.12988 18.5601 6.12988 18.1501V16.0801C6.12988 15.6701 6.46988 15.3301 6.87988 15.3301C7.28988 15.3301 7.62988 15.6701 7.62988 16.0801V18.1501C7.62988 18.5701 7.28988 18.9001 6.87988 18.9001Z",
    fill: "#888888"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M12 18.9C11.59 18.9 11.25 18.56 11.25 18.15V14C11.25 13.59 11.59 13.25 12 13.25C12.41 13.25 12.75 13.59 12.75 14V18.15C12.75 18.57 12.41 18.9 12 18.9Z",
    fill: "#888888"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M17.1201 18.8997C16.7101 18.8997 16.3701 18.5597 16.3701 18.1497V11.9297C16.3701 11.5197 16.7101 11.1797 17.1201 11.1797C17.5301 11.1797 17.8701 11.5197 17.8701 11.9297V18.1497C17.8701 18.5697 17.5401 18.8997 17.1201 18.8997Z",
    fill: "#888888"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M6.88007 13.1804C6.54007 13.1804 6.24007 12.9504 6.15007 12.6104C6.05007 12.2104 6.29007 11.8004 6.70007 11.7004C10.3801 10.7804 13.6201 8.77041 16.0901 5.90041L16.5501 5.36041C16.8201 5.05041 17.2901 5.01041 17.6101 5.28041C17.9201 5.55041 17.9601 6.02041 17.6901 6.34041L17.2301 6.88041C14.5601 10.0004 11.0401 12.1704 7.06007 13.1604C7.00007 13.1804 6.94007 13.1804 6.88007 13.1804Z",
    fill: "#888888"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M17.1199 9.51961C16.7099 9.51961 16.3699 9.17961 16.3699 8.76961V6.59961H14.1899C13.7799 6.59961 13.4399 6.25961 13.4399 5.84961C13.4399 5.43961 13.7799 5.09961 14.1899 5.09961H17.1199C17.5299 5.09961 17.8699 5.43961 17.8699 5.84961V8.77961C17.8699 9.18961 17.5399 9.51961 17.1199 9.51961Z",
    fill: "#888888"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M15 22.75H9C3.57 22.75 1.25 20.43 1.25 15V9C1.25 3.57 3.57 1.25 9 1.25H15C20.43 1.25 22.75 3.57 22.75 9V15C22.75 20.43 20.43 22.75 15 22.75ZM9 2.75C4.39 2.75 2.75 4.39 2.75 9V15C2.75 19.61 4.39 21.25 9 21.25H15C19.61 21.25 21.25 19.61 21.25 15V9C21.25 4.39 19.61 2.75 15 2.75H9Z",
    fill: "#888888"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAssets);
export default __webpack_public_path__ + "static/media/assets.324d3260a92f35bc4dd463de4517607c.svg";
export { ForwardRef as ReactComponent };